export default __webpack_public_path__ + "static/media/tooth.b8bcfbd0.svg";